/** Fixed column widths so header cells line up with body cells (table-layout: fixed). */
export const WEEKLY_MATRIX_SCHEDULE_COL_PX = 176;
export const WEEKLY_MATRIX_DAY_COL_PX = 164;

/** Total width for WeeklyPerDayMatrix (flex row: sticky schedule + day columns). */
export function weeklyMatrixTableWidthPx(dayCount) {
  return WEEKLY_MATRIX_SCHEDULE_COL_PX + dayCount * WEEKLY_MATRIX_DAY_COL_PX;
}

/** Day grid only (schedule column is fixed outside the scroll area). */
export function weeklyMatrixDayGridWidthPx(dayCount) {
  return dayCount * WEEKLY_MATRIX_DAY_COL_PX;
}

/** Keeps schedule rows visually aligned with day rows (min height). */
export const WEEKLY_MATRIX_ROW_MIN_HEIGHT_PX = 88;
